var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcNext = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#3f68b5;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M8-7.411l4.6-4.6L8-16.6,9.4-18l5.994,5.994L9.4-6.013Z",
  transform: "translate(-7 18)"
})))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 30,
  height: 30,
  rx: 4
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.466 9.021)"
}, /*#__PURE__*/React.createElement("g", {
  className: "c"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M20.381-1.024H3V-23H20.381Z",
  transform: "translate(-7.995 18.005)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_next.20072f417d8b28a0bf6168bef4f8f5ef.svg";